import { handleActions } from 'redux-actions';
import { showSidebar, hideSidebar } from './actions';

const defaultState = {
  showSidebar: false
};

export default handleActions({
  [showSidebar]: state => ({
    ...state, showSidebar: true
  }),
  [hideSidebar]: state => ({
    ...state, showSidebar: false
  })
},
defaultState);



// WEBPACK FOOTER //
// ./src/store/sidebar/reducer.js